import useUser from "@/api/apis";
import { ContentComment } from "@/models/ContentComment";
import { fetchData, Method } from "@/utils/fetcher";
import { useMutation } from "@tanstack/react-query";

const ContentCommentResourcePath = "/sdk-api/api/v2/content-comments";

interface AddContentCommentRequestBody {
  contentId: string;
  commentText: string;
  contentName: string;
  needContact: boolean;
}

export function useCreateContentComment() {
  const { token } = useUser();
  return useMutation({
    mutationFn: async (comment: AddContentCommentRequestBody) => {
      return await fetchData<ContentComment>({
        url: `${ContentCommentResourcePath}/`,
        token: token?.token,
        method: Method.POST,
        data: comment,
      });
    },
  });
}
